export type Page = "home" | "services" | "packages" | "contact";

export type NavigateFn = (path: string) => void;

export const WA_LINK = "https://wa.me/61431926269";
export const ABN = "ABN 28 635 744 688";

export const DARK_BG = "#1A1818";
export const DARK_CARD = "#242020";
export const DARK_BORDER = "rgba(255,255,255,0.08)";

export const PAGE_PATHS: Record<Page, string> = {
  home: "/",
  services: "/services",
  packages: "/packages",
  contact: "/contact",
};

export const NAV_LINKS: { label: string; page: Page; path: string }[] = [
  { label: "Home", page: "home", path: "/" },
  { label: "Services", page: "services", path: "/services" },
  { label: "Packages", page: "packages", path: "/packages" },
  { label: "Contact", page: "contact", path: "/contact" },
];

/** Map pathname to marketing page key (null = unknown / admin). */
export function pathToPage(pathname: string): Page | null {
  switch (pathname) {
    case "/":
      return "home";
    case "/services":
      return "services";
    case "/packages":
      return "packages";
    case "/contact":
      return "contact";
    default:
      return null;
  }
}

/** Client-side redirects from retired marketing URLs. */
export const LEGACY_REDIRECTS: Record<string, string> = {
  "/tradie-websites": "/services",
  "/local-seo-tradies": "/services",
  "/website-local-seo": "/packages",
  "/plumbers-sydney": "/",
  "/sydney-tradies": "/",
  "/aussie-tradies": "/",
};

export function titleForPath(pathname: string): string {
  switch (pathname) {
    case "/services":
      return "ONIN PTY LTD | Business Websites, Local SEO & Google Business Profile";
    case "/packages":
      return "ONIN PTY LTD | Website & Local SEO Packages for Australian Businesses";
    case "/contact":
      return "ONIN PTY LTD | Request a Free Website & SEO Quote";
    case "/admin-ads":
      return "ONIN PTY LTD | Google Ads Admin Campaign Audit";
    default:
      return "ONIN PTY LTD | Websites & Local SEO for Local Service Businesses";
  }
}
